import { Injectable } from '@angular/core';
import { DccAdapter } from './dcc.adapter';
import { Observable } from 'rxjs';

@Injectable()
export class DccConnector {
  constructor(protected adapter: DccAdapter) {}

  get(productData: string): Observable<any> {
    return this.adapter.getData(productData);
  }
}
